<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">{{ $t("cash") }} {{ $t("card") }}</div>
      <router-link class="btn-blue" :to="{ name: 'Cash Card Gallery' }">{{
        $t("cash_card_gallery")
      }}</router-link>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="w_cash_card_name"
                name="w_cash_card_name"
                v-model="cashCard.w_cash_card_name"
                v-validate="'required'"
                placeholder="Enter Cash Card Name"
                type="text"
              />
              <label>{{ $t("w_cash_card_name") }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('w_cash_card_name')"
              >{{ errors.first("w_cash_card_name") }}
            </span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 mb-2">
          <div class="row">
            <div class="col-10">
              <div class="d-flex align-items-center">
                <label
                  class="material-file-upload"
                  @click.prevent.stop="setModalData(637.5, 1011)"
                >
                  <div class="text-truncate p-2 font-weight-bold">
                    {{
                      cashCard.w_cash_card_image
                        ? cashCard.w_cash_card_image
                        : "Select Image"
                    }}
                  </div>
                </label>
              </div>
            </div>
            <div class="col-2 align-self-center p-0">
              <img
                width="40"
                height="40"
                class="rounded c-pointer img-preview"
                :src="_GetImagePath(cashCard.w_cash_card_image)"
                v-if="cashCard.w_cash_card_image"
              />
              <img
                v-else
                width="35"
                height="35"
                class="rounded"
                alt="Empty Image"
                src="@/assets/img/icons/empty-image.svg"
              />
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-3 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="issuer"
                name="issuer"
                v-validate="'required'"
                v-model="cashCard.w_issuer_name"
                placeholder="Card Issuer"
              />
              <label>{{ $t("issuer") }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('issuer')"
              >{{ errors.first("issuer") }}
            </span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-2 mb-2">
          <div class="d-flex align-items-center pt-2 justify-content-end">
            <b-form-checkbox
                type="checkbox"
                class="j-checkbox pb-0"
                v-model="cashCard.w_is_active"
                unchecked-value="N"
                value="Y"
              />

            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            
            
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
              class="text-right"
                id="w_professing_fee"
                name="w_professing_fee"
                v-validate="'required|numeric'"
                v-model="cashCard.w_professing_fee"
                placeholder="."
                v-on:keydown="
                  (e) => {
                    if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                      e.preventDefault();
                    }
                  }
                "
              />
              <label>{{ $t("w_professing_fee") }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('w_professing_fee')">
              {{ errors.first("w_professing_fee") }}
            </span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
              class="text-right"
                id="w_minimum_topup"
                name="w_minimum_topup"
                v-validate="'required|numeric'"
                v-model="cashCard.w_minimum_topup"
                placeholder="."
                v-on:keydown="
                  (e) => {
                    if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                      e.preventDefault();
                    }
                  }
                "
              />
              <label>{{ $t("w_minimum_topup") }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('w_minimum_topup')">
              {{ errors.first("w_minimum_topup") }}
            </span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
              class="text-right"
                placeholder="."
                v-model="cashCard.w_lead_time_days"
                type="text"
                v-validate="'required'"
                name="w_lead_time_days"
                id="w_lead_time_days"
                v-on:keydown="
                  (e) => {
                    if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                      e.preventDefault();
                    }
                  }
                "
              />
              <label>Lead Time (Days)</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('w_lead_time_days')"
              >{{ errors.first("w_lead_time_days") }}
            </span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4" v-if="false">
          <div class="row">
            <div class="col-6">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="leadTimeHH"
                    type="text"
                    name="leadTimeMM"
                    id="leadTimeMM"
                    maxlength="2"
                    v-validate="'numeric'"
                  />
                  <label>Lead Time (HH)</label>
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="leadTimeMM"
                    type="text"
                    name="leadTimeMM"
                    id="leadTimeMM"
                    maxlength="2"
                    v-validate="'numeric'"
                  />
                  <label>Lead Time (MM)</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4">
          <div class="input-material-textarea">
            <textarea
              id="w_description"
              name="w_description"
              v-model="cashCard.w_description"
              placeholder=""
              rows="2"
            ></textarea>
            <label>{{ $t("description") }}</label>
          </div>
        </div>
          <div class="col-lg-6 col-xl-4 align-self-center">
               <input
                  type="color"
                  name="font_color"
                  id="font_color"
                  v-model="cashCard.w_font_color"
                  placeholder="."
                  v-b-tooltip.hover
                    title="Text Color on Cash Card"
                />
               
                <label>Font Color </label>
                    <!--Tooltip title="Text Color on Cash Card" /-->
           </div>
          


        
      </div>

      <div class="text-center">
        <button @click.prevent.stop="saveCashCard()" class="btn-blue">
          {{ $t("save") }}
        </button>
      </div>
    </div>

    <ImageGallery
      v-bind:propImageName="'Cash Card Artwork'"
      v-bind:openModal="showModal"
      v-bind:set_height="set_height"
      v-bind:set_width="set_width"
      :category="'Cash Card'"
      :menu="'F'"
    ></ImageGallery>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MarketingService from "@/services/MarketingService";
import { mapGetters } from "vuex";
import ImageGallery from "@/components/Pages/ImageGallery/imageGalleryModal";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { generateRandomCode, UniqueRandomNumber } from "@/helper/collection";

export default {
  components: { VueCropper, ImageGallery },
  data() {
    return {
      leadTimeHH: "00",
      leadTimeMM: "00",
      cashCard: {
        w_cash_card_id: "",
        w_font_color:"",
        w_cash_card_image: "",
        w_cash_card_name: "",
        w_issuer_name: "",
        w_cash_card_unique_id:"",
        w_lead_time: "00:00",
        w_minimum_topup: "",
        w_professing_fee: "",
        w_description: "",
        w_lead_time_days: "",
        w_is_active: "Y",
      },
      set_height: null,
      set_width: null,
      showModal: false,
      submitted: false,
    };
  },
  beforeMount() {
    const { w_cash_card_unique_id } = this.$route.query;
    if (w_cash_card_unique_id) {
      this.getEditCashCardTemplate(w_cash_card_unique_id);
    } else {
      this.cashCard.w_issuer_name = this.getOrganizationDetails
        ? this.getOrganizationDetails.org_name
        : "";
    }
  },
  mounted() {},
  computed: {
    ...mapGetters(["finalImagePath", "getOrganizationDetails"]),
  },
  watch: {
    finalImagePath(newval) {
      console.log("newval", newval);
      this.cashCard.w_cash_card_image = newval;
    },
  },
  methods: {
    saveCashCard() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (!this.cashCard.w_cash_card_image) {
            return this.$toasted.show("Please Select Image");
          }
          let loader = this.$loading.show();
          this.cashCard.w_lead_time = `${this.leadTimeHH}:${this.leadTimeMM}`;
          let payload = {
            ...this.cashCard,
          };
          MarketingService.AddCashCardTemplate(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.$toasted.show(data.message);
                this.$router.push({
                  path: "/marketing/list-cash-cards-gallery",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally((err) => {
              loader.hide();
            });
        } else {
          this.$toasted.show("Please enter all details");
        }
      });
    },
    getEditCashCardTemplate(uniqueId) {
      let payload = {
        w_cash_card_unique_id: uniqueId,
      };
      MarketingService.GetSingleCashCardTemplate(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.cashCard = data.Records[0];
            Object.keys(this.cashCard).map((x) => {
              this.cashCard[x] = data.Records[0][x];
            });
            let split = data.Records[0].w_lead_time.split(":");
            if (split.length) {
              this.leadTimeHH = split[0];
              this.leadTimeMM = split[1];
            } else {
              this.leadTimeHH = "00";
              this.leadTimeMM = "00";
            }
          } else {
            console.log("Error:", data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    setModalData(height, width) {
      this.set_height = height;
      this.set_width = width;
      this.showModal = !this.showModal;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CashCardGallery/WebsiteCashCard.vue